import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Logger, BusyState } from 'projects/common/src/app/classes';
import { AuthenticationService } from 'src/app/services/authentication';


@Injectable({
  providedIn: 'root'
})
export class CanDeactivateLoginService extends Logger implements CanDeactivate<BusyState> {

  constructor(
    private authService: AuthenticationService
  ) {
    super();
  }

  /**
   * CanDeactivate
   */
  public canDeactivate(
    component: BusyState,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve) => resolve(this.authService.isAuth()));
  }
}
